export default __webpack_public_path__ + "static/media/Helm of Tranquility.93499385.jpg";